export default function ({commit, dispatch}, {id, cb}) {
    commit('loading', true);
    axios({
        method: 'get',
        url: `/tourclient/api/giftCertificate?id=${id}&GetSubsidies=true`,
    }).then(({data}) => {
        commit('loading');
        if (HasError(data)) return;
        if (cb) cb(data);
    }).catch(e => {
        commit('loading');
        dispatch('error', e, {root: true});
    })
}